"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactRedux = require("react-redux");
var _reduxStore = require("../redux/reduxStore");
var _formSlice = require("../redux/slices/formSlice");
var _excluded = ["additionalSlices", "createNewStore", "preloadedState", "nonSerializableActions"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var FormInner = function FormInner(props) {
  var dispatch = (0, _reactRedux.useDispatch)();
  (0, _react.useEffect)(function () {
    if (props.initialValues) {
      dispatch((0, _formSlice.setInitialValues)({
        initialValues: props.initialValues
      }));
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, props.children);
};
FormInner.propTypes = {
  children: _propTypes["default"].node,
  initialValues: _propTypes["default"].object
};
var Form = function Form(props) {
  var additionalSlices = props.additionalSlices,
    _props$createNewStore = props.createNewStore,
    createNewStore = _props$createNewStore === void 0 ? false : _props$createNewStore,
    preloadedState = props.preloadedState,
    nonSerializableActions = props.nonSerializableActions,
    rest = _objectWithoutProperties(props, _excluded);
  var getStoreInner = createNewStore ? _reduxStore.createStore : _reduxStore.getStore;
  var store = (0, _react.useRef)(getStoreInner(additionalSlices, preloadedState, nonSerializableActions));
  return /*#__PURE__*/_react["default"].createElement(_reactRedux.Provider, {
    store: store.current
  }, /*#__PURE__*/_react["default"].createElement(FormInner, rest));
};
Form.propTypes = {
  additionalSlices: _propTypes["default"].object,
  children: _propTypes["default"].node,
  createNewStore: _propTypes["default"].bool,
  initialValues: _propTypes["default"].object,
  preloadedState: _propTypes["default"].object,
  nonSerializableActions: _propTypes["default"].array
};
var _default = exports["default"] = Form;